import { get, omit } from 'lodash';

export const getFormattedDataWithTimeSlots = (productsWithTimeSlotsAllocations) => {
  const formattedDataWithTimeSlots = productsWithTimeSlotsAllocations.map((productWithTSA) => {
    const { dataByTimeSlotIds } = productWithTSA;

    let total = 0;

    const formattedDataByTimeSlotIds = Object.entries(dataByTimeSlotIds).reduce(
      (acc, [ptsId, ptsValue]) => {
        acc[ptsId] = get(ptsValue, 'ratio', null);
        total += acc[ptsId] || 0;
        return acc;
      },
      {},
    );

    return {
      ...omit(productWithTSA, 'dataByTimeSlotIds'),
      ...formattedDataByTimeSlotIds,
      total,
    };
  });

  return formattedDataWithTimeSlots;
};
